<fdx-common-core>

    <app-header *ngIf="isSmallScreen" [opened]="opened" [isSmallScreen]="isSmallScreen"></app-header>

    <mat-sidenav-container [hasBackdrop]="false" class="side-nav">
        <!--
<mat-sidenav #appDrawer mode="over" [(opened)]="opened" (opened)="openClosed('open')" (closed)="openClosed('close')"> -->

        <app-header *ngIf="!isSmallScreen" [opened]="opened"></app-header>

        <div class="fdx-o-grid fxg-wrapper-main fdx-main-layout-wrapper" [ngClass]="{
        'fxg-wrapper': router.url !== '/home',
        'fxg-wrapper-home': router.url === '/home'
      }">
            <mat-sidenav #appDrawer mode="over" [ngStyle]="{'display':opened ? 'block' : 'none' }" [hidden]="router.url === '/home'" [opened]="!isSmallScreen" (opened)="openClosed('open')" (closed)="openClosed('close')" [autoFocus]="true" fullscreen>
                <!--over/push-->
                <div (change)="updateResults()" (keyup)="updateResults()">
                    <form class="search-form" autocomplete="off" class="form">

                        <div class="fdx-c-form-group fdx-c-form-group--float-label" [ngClass]="{'fdx-c-form-group--has-value': (searchValue!==null&&searchValue!=='')}">
                            <div class="fdx-c-form-group__item">
                                <input type="text" class="fdx-c-form-group__input" [(ngModel)]="searchValue" name="searchValue" aria-describedby="alertID">
                                <label class="fdx-c-form-group__label fdx-c-form-group__label__trunc fdx-c-form-group__label--dark">
                                    {{"COMMON.CommonLayoutInput_Searchmenu" | translate: {Default: "Search Menu"} }}
                                </label>
                                <button type="reset" class="fdx-u-myt--4 fdx-u-mr--2 fdx-reset" *ngIf="searchValue" (click)="resetNavItems()">
                                    <div class="none">

                                        <svg class="fdx-c-icon " aria-hidden="true" focusable="false" role="presentation">
                                            <use xlink:href="#cross"></use>
                                        </svg>

                                    </div>
                                </button>
                                <a class="fdx-u-mt--4 fdx-u-mr--2">
                                    <div class="none">
                                        <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                                            <use xlink:href="#loupe"></use>
                                        </svg>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </form>
                </div>

                <mat-nav-list>
                    <app-menu-list-item *ngFor="let item of filteredItems" [item]="item" [isSmallScreen]="isSmallScreen">
                    </app-menu-list-item>
                </mat-nav-list>
            </mat-sidenav>
            <main>
                <div class="fxg-margin-top-100 fxg-main-content col-12 content-wrapper-right">
                    <div class="fdx-c-loading-indicator fdx-c-loading-indicator-wcenter" *ngIf="isLoading | async" [hidden]="router.url === '/home'" mode="indeterminate" color="warn" style="z-index: 5000;">
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                        <div class="fdx-c-loading-indicator__part"></div>
                    </div>
                    <router-outlet></router-outlet>
                </div>
            </main>
        </div>
    </mat-sidenav-container>
    <app-footer></app-footer>
</fdx-common-core>